<template>
  <k-autocomplete v-bind:items="items" v-model="val" :label="label || title" :item-text="itemText" :item-value="itemValue" :multiple="multiple"></k-autocomplete>
</template>

<script>
export default {
  props: {
    'name': String,
    'label': String,
    'title': String,
    'items': {
      type: Array,
      default () { return [] }
    },
    'default_item': String,
    'item-text': {
      type: String,
      default: "name"
    },
    'item-value': {
      type: String,
      default: "id"
    },
    'value': {
      type: Object,
      default () { return {}; }
    },
    'multiple': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    if(!this.val) this.val = this.default_item;
  }
}
</script>
